import React, { useState, useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { Dimmer, Loader, Progress, Transition } from 'semantic-ui-react';

import ErrorModal from './Modals/ErrorModal';
import { persistor } from './../../App';

const Wrapper = (props) => {
    const [showLoader, setShowLoader] = useState(false);
    const [showProgress, setShowProgress] = useState(false);
    const [showError, setShowError] = useState(false);
    const isInitialMount = useRef(true);
    const routeHistory = useHistory();

    useEffect(() => {
        setShowLoader(false);
        props.clearLoaders();
    },[])

    useEffect(() => {
        if(isInitialMount.current) {
            window.scrollTo(0, 0);
            isInitialMount.current = false;
        }
        else {
            if(props.showProgress) {
                document.body.style.overflowY = "hidden";
                setShowProgress(props.showProgress);
            }
            else {
                setTimeout(() => {
                    document.body.style.overflowY = null;
                    setShowProgress(props.showProgress);
                    if(routeHistory)
                        routeHistory.push(props.route);
                }, 2000);
            }
        }
    }, [props.showProgress])

    useEffect(() => {
        if(props.loader)
            document.body.style.overflowY = "hidden";
        else
            document.body.style.overflowY = null;
        setShowLoader(props.loader);
    }, [props.loader])

    useEffect(() => {
        if(isInitialMount.current) {
            isInitialMount.current = false;
        }
        else {
            document.body.style.overflowY = null;
            if(!!props.error && !!props.error.response) {
                setShowLoader(false);
                setShowProgress(false);
                if(props.error.response.status == 401) {
                    props.clearError();
                    persistor.purge();
                    props.logout();
                    routeHistory.push(`/`);
                }
                else
                    setShowError(true);
            }
        }
    }, [props.error])

    function handleClose () {
        props.clearLoaders();
    }

    let progressStyle = {
        fontSize: 18,
        width: 300,
        display:"flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center"
    }

    let errorStyle = {
        position: "absolute",
        height: 50,
        width: 300,
        backgroundColor: "yellow",
        fontSize: 18,
        left: 0,
        right: 0,
        marginLeft: "auto",
        marginRight: "auto",
        textAlign: "center",
        paddingTop: 15,
        zIndex: 1001
    }

    return (
        <div style={{width:"100%", height:"100%"}}>
            {/* <Transition animation="fly down" duration="1000" visible={showError}>
                <div style={errorStyle}>{(!!props.error && !!props.error.response) ? `${props.error.response.status}: ${props.error.response.statusText}` : ""}</div>
            </Transition> */}
            <Dimmer active={showLoader || showProgress} style={{position: "fixed"}} onClickOutside={handleClose}>
            {
                (showProgress) &&
                <div style={progressStyle}>
                    {props.message}
                    <Progress
                        style={{width:300}}
                        indicating
                        percent={props.progress}
                        size="medium"
                    />
                </div>
            }
            {
                (showLoader) &&
                <Loader />
            }
            </Dimmer>
            {props.children}
            <ErrorModal 
                open={showError}
                closeModals={() => {setShowError(false);setShowLoader(false)}}
                error={props.error}
                company={props.company}
                location={props.loc}
                user_details={props.user_details}
                startTime={props.startTime}
                stopTime={props.stopTime}
                updateDisposition={props.updateDisposition}
            />
        </div>
    )
}

Wrapper.defaultProps = {
    error: null,
    loader: false,
    show_progress: false
}

export default Wrapper;